module.exports = __webpack_public_path__ + "media/images/top/for-beginner-56e27d342a1b01d459ecc0ffa35bc6db.webp";